<div class="content" style="background: none">
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats">
            <div class="card-header card-header-warning card-header-icon">
              <div class="card-icon">
                <i class="material-icons">weekend</i>
              </div>
              <p class="card-category">Announces Count</p>
              <h3 class="card-title">{{announcesCount}}</h3>
            </div>
            <div class="card-footer">
              <div class="stats">
                <i class="material-icons text-success">add</i>
                <a class="text-success" href="javascript:void(0)" (click)="router.routeTo('add-announce', 'dashboard', true)">Add more announces...</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats">
            <div class="card-header card-header-rose card-header-icon">
              <div class="card-icon">
                <i class="material-icons">equalizer</i>
              </div>
              <p class="card-category">Website Visits</p>
              <h3 class="card-title">75.521</h3>
            </div>
            <div class="card-footer">
              <div class="stats">
                <i class="material-icons">local_offer</i> Tracked from Google Analytics
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats">
            <div class="card-header card-header-success card-header-icon">
              <div class="card-icon">
                <i class="material-icons">store</i>
              </div>
              <p class="card-category">Revenue</p>
              <h3 class="card-title">$34,245</h3>
            </div>
            <div class="card-footer">
              <div class="stats">
                <i class="material-icons">date_range</i> Last 24 Hours
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats">
            <div class="card-header card-header-info card-header-icon">
              <div class="card-icon">
                <i class="fa fa-twitter"></i>
              </div>
              <p class="card-category">Followers</p>
              <h3 class="card-title">+245</h3>
            </div>
            <div class="card-footer">
              <div class="stats">
                <i class="material-icons">update</i> Just Updated
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid" style="background-color: rgba(255, 255, 255, 0.9); border-radius: 10px; margin-bottom: 10px">
        <div class="container">
          <h3 class="text-center font-weight-bold p-4" style="color: white; font-size: 40px; margin-bottom: 30px; background-color: rgb(156,39,176); border-bottom-right-radius: 30px; border-bottom-left-radius: 30px">
            <i class="material-icons mr-2" style="font-size: 40px">filter</i>Your Announces</h3>
          <br>
          <div class="row">
            <div class="col-md-4" *ngFor="let a of announces">
              <app-card-announce [id]="a.id" [title]="a.title" [description]="a.description" [city]="a.city" [price]="a.price" [images]="a.images" [created_at]="a.created_at"></app-card-announce>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
